<template>
  <h4 class="text-center mb-4">チャットボット一覧</h4>
  <CRow>
    <CCol :md="3"></CCol>
  </CRow>
  <CRow>
    <CCol :md="3"></CCol>
    <CCol :md="3"></CCol>
    <CCol :md="1"></CCol>

    <CCol :md="3">
      <!-- <CButton color="dark" @click="startCreateChatbotWizard">
        <CIcon :icon="cilPlus" size="xl" />
        Create Chatbot
      </CButton> -->
    </CCol>
  </CRow>

  <CRow>
    <!-- add empty column for left spacing -->
    <CCol :md="12">
      <div class="card-wrapper">
        <CRow>
          <CCard style="margin-bottom: 10px">
            <CCardBody align="center">
              <CButton
                @click="startCreateChatbotWizard"
                style="font-weight: bold; font-size: 18px"
                class="mb-0"
              >
                <img
                  src="../../public/images/robot.gif"
                  width="50"
                  height="50"
                />
                チャットボット新規作成
              </CButton>
              <br />
            </CCardBody>
          </CCard>
        </CRow>
        <CRow v-if="filteredChatbots.length > 0">
          <CCard>
            <CModalBody>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th
                        style="width: 100px"
                        class="text-uppercase text-secondary text-xs font-weight-bolder ps-2"
                      >
                        <soft-button
                          class="btn-sm px-3 mb-2"
                          variant="gradient"
                          color="warning"
                          @click="registerOrders"
                        >
                          登録 </soft-button
                        ><br />
                        <span class="ms-2">表示順</span>
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xs font-weight-bolder ps-2"
                      >
                        ステータス
                      </th>
                      <th
                        style="width: 60px"
                        class="text-uppercase text-secondary text-xs font-weight-bolder ps-2"
                      >
                        操作
                      </th>
                      <th
                        style="width: 60px"
                        class="text-uppercase text-secondary text-xs font-weight-bolder ps-2"
                      ></th>
                      <th
                        style="width: 60px"
                        class="text-uppercase text-secondary text-xs font-weight-bolder ps-2"
                      ></th>
                      <th
                        class="text-uppercase text-secondary text-xs font-weight-bolder"
                      >
                        チャットボット名
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xs font-weight-bolder ps-2"
                      >
                        ファイル名
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="chatbot in filteredChatbots" :key="chatbot.id">
                      <td>
                        <div class="input-group">
                          <input
                            type="text"
                            class="form-control"
                            v-model="chatbot.display_order"
                            :disabled="!chatbot.public"
                            @input="
                              chatbot.display_order =
                                $event.target.value.replace(/[^0-9]/g, '')
                            "
                          />
                        </div>
                      </td>
                      <td>
                        <span v-if="chatbot.public" class="badge badge-success">
                          公開中
                        </span>
                        <span v-else class="badge badge-secondary">
                          非公開
                        </span>
                      </td>
                      <td>
                        <CButton
                          class="btn-sm mb-0 px-2"
                          color="secondary"
                          variant="outline"
                          @click="launchChatbotSettings(chatbot)"
                        >
                          <CIcon
                            :icon="cilSettings"
                            style="width: 1.2rem; height: 1.2rem"
                            class="me-1"
                          />
                          詳細
                        </CButton>
                      </td>
                      <td>
                        <CButton
                          class="btn-sm mb-0 px-2"
                          color="secondary"
                          variant="outline"
                          @click="startChatbot(chatbot)"
                        >
                          <CIcon
                            :icon="cilMediaPlay"
                            style="width: 1.2rem; height: 1.2rem"
                            class="me-1"
                          />
                          開始
                        </CButton>
                      </td>
                      <td>
                        <CButton
                          class="btn-sm mb-0 px-2"
                          color="secondary"
                          variant="outline"
                          @click="updateChatbot(chatbot)"
                        >
                          <CIcon
                            :icon="cilLibraryAdd"
                            style="width: 1.2rem; height: 1.2rem"
                            class="me-1"
                          />
                          追加
                        </CButton>
                      </td>
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <CIcon
                              :icon="cilTrash"
                              style="width: 1.2rem; height: 1.2rem"
                              class="text-danger cursor-pointer me-1"
                              @click="deleteChatbot(chatbot.id)"
                            />
                            <h6 class="mb-0 text-sm">{{ chatbot.name }}</h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <ul class="ps-3 mb-0">
                          <li
                            v-for="line in splitText(chatbot.subject)"
                            :key="line"
                            class="d-flex py-1"
                          >
                            <CIcon
                              :icon="cilTrash"
                              style="width: 1rem; height: 1rem"
                              class="text-danger cursor-pointer me-1"
                              @click="deleteFile(chatbot.id, line)"
                            /><span class="text-xs">{{ line }}</span>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </CModalBody>
          </CCard>
        </CRow>
      </div>
    </CCol>
    <!-- add empty column for right spacing -->
  </CRow>

  <CModal
    alignment="center"
    scrollable
    :visible="showSettingsModal"
    @close="
      () => {
        showSettingsModal = false
      }
    "
  >
    <CModalHeader>
      <CModalTitle>{{ editingChatbot ? '編集画面' : '新規作成' }}</CModalTitle>
    </CModalHeader>
    <CModalBody>
      <form>
        <div class="form-group">
          <label for="name">チャットボット名</label>
          <input
            type="text"
            class="form-control"
            id="name"
            v-model="editingChatbot.name"
          />
        </div>
        <div class="form-group">
          <label for="subject">サブタイトル</label>
          <input
            type="text"
            class="form-control"
            id="subject"
            v-model="editingChatbot.subject"
            disabled
          />
        </div>
        <div class="form-group">
          <label for="created">作成日時</label>
          <input
            type="datetime-local"
            class="form-control"
            id="created"
            v-model="editingChatbot.created"
            disabled
          />
        </div>
        <div class="form-group">
          <label for="prompt">プロンプト</label>
          <textarea
            class="form-control"
            id="prompt"
            rows="3"
            v-model="editingChatbot.prompt"
          ></textarea>
          <label for="prompt">
            注: デフォルトのプロンプトを使用する場合は、未入力にしてください
          </label>
        </div>
        <div class="form-group">
          <label for="characters">文字数</label>
          <input
            disabled="true"
            type="number"
            class="form-control"
            id="characters"
            v-model="editingChatbot.characters"
          />
        </div>
        <div class="form-check ps-0">
          <label class="form-label d-block mb-1">公開ステータス</label>

          <div class="form-check form-check-inline ms-1">
            <input
              class="form-check-input"
              type="radio"
              id="public-yes"
              value="1"
              v-model="editingChatbot.public"
            />
            <label class="form-check-label" for="public-yes">公開中</label>
          </div>

          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              id="public-no"
              value="0"
              v-model="editingChatbot.public"
            />
            <label class="form-check-label" for="public-no">非公開</label>
          </div>
        </div>
        <!-- <div v-if="editingChatbot.public === 1" class="form-group">
          <label for="url_snippet">URL Snippet</label>
          <input
            type="text"
            class="form-control"
            id="url_snippet"
            :value="'https://chatbotanything.com/chatbot/' + editingChatbot.id"
          />
        </div> -->
      </form>
    </CModalBody>
    <CModalFooter>
      <div class="d-flex justify-content-center w-100">
        <button
          class="btn bg-gradient-secondary mb-0 me-3"
          @click="
            () => {
              showSettingsModal = false
            }
          "
        >
          <i class="fas fa-times me-1"></i> 閉じる
        </button>
        <button
          class="btn bg-gradient-warning mb-0"
          @click="saveChatbotSettings"
        >
          <i class="fas fa-clipboard-check me-1"></i> 保 存
        </button>
      </div>
    </CModalFooter>
  </CModal>

  <div>
    <CModal
      :visible="showHistoryModal"
      @close="
        () => {
          showHistoryModal = false
        }
      "
      size="lg"
    >
      <CModalHeader>
        <CModalTitle>Conversation History</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <div
          v-for="conversation in conversations"
          :key="conversation.conversation_id"
          class="card mb-3"
        >
          <div class="card-body">
            <h5 class="card-title">
              Conversation ID: {{ conversation.conversation_id }}
            </h5>
            <p class="card-text">Created: {{ conversation.created }}</p>
            <a
              href="#"
              @click.prevent="
                resumeChatbot(conversation.bot_id, conversation.conversation_id)
              "
              class="btn btn-info white-text"
              target="_blank"
              >Resume Conversation</a
            >
          </div>
        </div>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" @click="showHistoryModal = false"
          >Close</CButton
        >
      </CModalFooter>
    </CModal>
    <CModal
      :visible="showChatbotDesignModal"
      backdrop="static"
      @close="closeChatbotDesignModal"
      size="lg"
    >
      <CModalHeader>
        <CModalTitle>Chatbot Design</CModalTitle>
      </CModalHeader>

      <CRow>
        <CCol md="5" style="margin-left: 20px">
          <div>
            <div class="chatbot-input-label">Chatbot Heading:</div>
            <input
              type="text"
              class="chatbot-input"
              id="chatbotheading"
              v-model="editingChatbot.chatbotheading"
            />
          </div>

          <div>
            <div class="chatbot-input-label">Chatbot SubHeading:</div>
            <input
              type="text"
              class="chatbot-input"
              id="chatbotsubheading"
              v-model="editingChatbot.chatbotsubheading"
            />
          </div>

          <div>
            <div class="chatbot-input-label">Logo Image:</div>
            <input
              type="file"
              accept=".jpeg, .png, .jpg, .gif, .svg"
              id="image"
              @change="onFileSelect($event)"
            />
          </div>

          <div class="d-flex justify-content-between chatbot-setting-row">
            <div class="chatbot-input-label">Header Text Color:</div>

            <input
              type="color"
              class="chatbot-input-color"
              id="headertextcolor"
              v-model="editingChatbot.headertextcolor"
            />
          </div>

          <div class="d-flex justify-content-between chatbot-setting-row">
            <div class="chatbot-input-label">Header Background Color:</div>
            <input
              type="color"
              class="chatbot-input-color"
              id="headerbackgroundcolor"
              v-model="editingChatbot.headerbackgroundcolor"
            />
          </div>

          <div>
            <div class="chatbot-input-label">Greeting:</div>
            <input
              type="text"
              class="chatbot-input"
              id="firstmessage"
              v-model="editingChatbot.firstmessage"
            />
          </div>

          <div>
            <div class="chatbot-input-label">Assistant Name:</div>
            <input
              type="text"
              class="chatbot-input"
              id="assistantname"
              v-model="editingChatbot.assistantname"
            />
          </div>

          <div class="d-flex justify-content-between chatbot-setting-row">
            <div class="chatbot-input-label">Chatbot Text Color:</div>
            <input
              type="color"
              class="chatbot-input-color"
              id="bottextcolor"
              v-model="editingChatbot.bottextcolor"
            />
          </div>

          <div class="d-flex justify-content-between chatbot-setting-row">
            <div class="chatbot-input-label">Chatbot Background Color:</div>
            <input
              type="color"
              class="chatbot-input-color"
              id="botbackgroundcolor"
              v-model="editingChatbot.botbackgroundcolor"
            />
          </div>

          <div class="d-flex justify-content-between chatbot-setting-row">
            <div class="chatbot-input-label">User Text Color:</div>
            <input
              type="color"
              class="chatbot-input-color"
              id="usertextcolor"
              v-model="editingChatbot.usertextcolor"
            />
          </div>

          <div class="d-flex justify-content-between chatbot-setting-row">
            <div class="chatbot-input-label">User Background Color:</div>
            <input
              type="color"
              class="chatbot-input-color"
              id="userbackgroundcolor"
              v-model="editingChatbot.userbackgroundcolor"
            />
          </div>

          <div>
            <div class="chatbot-input-label">Input Placeholder Text:</div>
            <input
              type="text"
              class="chatbot-input"
              id="inputplaceholdertext"
              v-model="editingChatbot.inputplaceholdertext"
            />
          </div>

          <div class="d-flex justify-content-between chatbot-setting-row">
            <div class="chatbot-input-label">Send Button Background Color:</div>
            <input
              type="color"
              class="chatbot-input-color"
              id="sendbuttonbackgroundcolor"
              v-model="editingChatbot.sendbuttonbackgroundcolor"
            />
          </div>
          <div
            class="d-flex justify-content-between"
            style="margin-bottom: 20px"
          >
            <CButton color="secondary" @click="closeChatbotDesignModal">
              Close
            </CButton>
            <CButton color="info" class="white-text" @click="saveChatbotDesign"
              >Save</CButton
            >
          </div>
        </CCol>
        <CCol :md="6" class="d-flex align-items-center justify-content-center">
          <component
            :is="activeComponent"
            bot_id="preview"
            :style="getEditingStyle(editingChatbot)"
            :key="editingChatbot.firstmessage"
          ></component>
        </CCol>
      </CRow>
      <CRow> </CRow>
    </CModal>
  </div>
  <ProcessingOverlay :show="isProcessing" />
</template>
<script>
import HTTPService from '@/services/HTTPService.js'
import { CCardText } from '@coreui/vue'
import { CIcon } from '@coreui/icons-vue'
import ProcessingOverlay from '@/components/ProcessingOverlay.vue'
import {
  cilMediaPlay,
  cilSettings,
  cilPlus,
  cilLibraryAdd,
  cilHistory,
  cilBrush,
  cilTrash,
} from '@coreui/icons'
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
} from '@coreui/vue'

import Chatbot from './Chatbot.vue'
import { NAV_MASTER } from '@/constants/navMaster'
import SoftButton from '@/components/SoftButton.vue'
import { getTenantId, isTenantRoute } from '@/constants/tenants'

// import * as icon from '@coreui/icons'
export default {
  data() {
    return {
      chatbots: [],
      item: { color: 'dark', textColor: 'white' },
      cilMediaPlay,
      cilSettings,
      cilPlus,
      cilLibraryAdd,
      cilHistory,
      cilBrush,
      cilTrash,
      showSettingsModal: false,
      editingChatbot: {},
      showHistoryModal: false,
      conversations: [],
      showChatbotDesignModal: false,
      activeComponent: Chatbot,
      isProcessing: false,
    }
  },
  props: {
    bot_id: {
      type: [String, Number],
      default: '',
    },
    botType: {
      type: String,
      default: '',
    },
    chatbot_name: {
      type: String,
      default: '',
    },
    conversation_id: {
      type: [String, Number],
      default: '',
    },
  },
  emits: ['changeActiveComponent'],
  mounted() {
    this.getChatbots()
  },
  computed: {
    filteredChatbots() {
      return this.chatbots.filter(
        (chatbot) => !chatbot.name.startsWith('[POC] '),
      )
    },
  },
  methods: {
    onFileSelect(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        const img = new Image()

        img.onload = () => {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')

          canvas.width = 40
          canvas.height = 40

          // Draw the image onto the canvas with the desired dimensions
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

          // Get the resized image as a base64 encoded string
          const resizedBase64Data = canvas.toDataURL('image/png').split(',')[1]

          // Update the editingChatbot image property
          this.editingChatbot.image =
            'data:image/png;base64,' + resizedBase64Data
        }

        // Set the image source to the loaded data
        img.src = e.target.result
      }

      if (file) {
        reader.readAsDataURL(file)
      } else {
        this.editingChatbot.image = null // Set .image to null if no file is selected
      }
    },
    getEditingStyle(editingChatbot) {
      // console.log('this is getEditingStyle on loading ')
      // console.log(editingChatbot)
      // be carefull not to use chatbot.style for saving/binding values
      return {
        chatbotHeading: editingChatbot.chatbotheading,
        chatbotSubHeading: editingChatbot.chatbotsubheading,
        firstMessage: editingChatbot.firstmessage,
        headerBackgroundColor: editingChatbot.headerbackgroundcolor,
        headerTextColor: editingChatbot.headertextcolor,
        image: editingChatbot.image,
        inputPlaceholderText: editingChatbot.inputplaceholdertext,
        sendButtonBackgroundColor: editingChatbot.sendbuttonbackgroundcolor,
        userBackgroundColor: editingChatbot.userbackgroundcolor,
        userTextColor: editingChatbot.usertextcolor,
        botBackgroundColor: editingChatbot.botbackgroundcolor,
        botTextColor: editingChatbot.bottextcolor,
        assistantName: editingChatbot.assistantname,
      }
    },
    updateChatbot(chatbot) {
      this.$emit('change-active-component', {
        component: 'ChatbotStep1',
        params: { bot_id: chatbot.id, chatbot_name: chatbot.name },
      })
    },
    async getChatbots() {
      try {
        const chatbots = await HTTPService.get_chatbots(
          NAV_MASTER.RAG_CHAT,
          getTenantId(this.$route),
        )
        // console.log(chatbots.data)
        this.chatbots = chatbots.data
      } catch (error) {
        console.log(error)
        this.$emit('change-active-component', {
          component: 'Login',
        })
      }
    },
    startCreateChatbotWizard() {
      this.$emit('change-active-component', {
        component: 'ChatbotStep1',
      })
    },
    launchChatbot(chatbot) {
      // launch selected chatbot
      // eslint-disable-next-line no-unused-vars
      chatbot = null
    },
    launchChatbotSettings(chatbot) {
      //console.log(chatbot)
      //console.log('chatbot.public')
      //console.log(chatbot.public === 1)

      this.editingChatbot = chatbot
      this.showSettingsModal = true
      // console.log(this.editingChatbot)
    },
    openChatbotDesign(chatbot) {
      // This object should contain the existing chatbot properties
      this.editingChatbot = chatbot
      // console.log(this.editingChatbot)
      // Show the chatbot design modal
      this.showChatbotDesignModal = true
    },
    closeChatbotDesignModal() {
      // Close the chatbot design modal
      this.showChatbotDesignModal = false
    },
    async saveChatbotDesign() {
      try {
        const response = await HTTPService.update_chatbot(this.editingChatbot)
        console.log(response.data)
        this.getChatbots()
        this.showChatbotDesignModal = false
      } catch (error) {
        console.log(error)
      }
    },
    showHistory(chatbot) {
      //console.log(chatbot)
      //console.log('chatbot.public')
      //console.log(chatbot.public === 1)

      this.editingChatbot = chatbot
      this.showSettingsModal = true
      //console.log(this.showSettingsModal)
    },
    async saveChatbotSettings() {
      try {
        const response = await HTTPService.update_chatbot(this.editingChatbot)
        console.log(response.data)
        this.showSettingsModal = false
        this.getChatbots()
      } catch (error) {
        console.log(error)
      }
    },
    startChatbot(chatbot) {
      // const name = 'My Bot' // replace with actual bot name
      // this.$router.push({ name: 'Chatbot', params: { bot_id } })
      //this.$emit('change-active-component', {
      //  component: 'Chatbot',
      //  params: { bot_id: bot_id },
      //})
      this.$store.commit('updateInitChatBot', chatbot)

      // router.resolve でルート情報を URL に変換
      const routeData = this.$router.resolve({
        name: isTenantRoute(this.$route)
          ? 'TenantControlPanelConfirm'
          : 'ChatbotSettingConfirm',
        query: { bot_id: chatbot.id },
      })

      // 別タブで開く
      window.open(routeData.href, '_blank')
    },
    resumeChatbot(bot_id, conversationId) {
      this.showHistoryModal = true
      // console.log(bot_id + ' conv:' + conversationId)
      // this.$emit('change-active-component', {
      //   component: 'Chatbot',
      //   params: { bot_id: bot_id },
      // })
      this.$emit('change-active-component', {
        component: 'Chatbot',
        params: { bot_id: bot_id, conversation_id: conversationId },
      })
    },

    async getConversationHistory(chatbot) {
      try {
        console.log(chatbot.id)
        const response = await HTTPService.get_conversation_history(chatbot.id)
        //console.log(response)
        this.conversations = response.data
        this.showHistoryModal = true
      } catch (error) {
        console.error(error)
      }
    },
    splitText(text) {
      const lines = text.split('||')
      let items = []
      for (let i = 0; i < lines.length; i++) {
        const parts = lines[i].split(';')
        for (let j = 0; j < parts.length; j++) {
          if (parts[j]) {
            items.push(parts[j])
          }
        }
      }
      return items
    },
    async deleteFile(bot_id, filename) {
      try {
        const data = {
          bot_id: bot_id,
          filename: filename,
        }
        this.isProcessing = true
        await HTTPService.delete_file(data)
        await this.getChatbots()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    async deleteChatbot(bot_id) {
      try {
        const data = {
          bot_id: bot_id,
        }
        this.isProcessing = true
        await HTTPService.delete_chatbot(data)
        await this.getChatbots()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    allowOnlyNumbers(event) {
      // 数字・制御キー（Backspace, Tab, 矢印キーなど）は許可
      if (
        /[0-9]/.test(event.key) ||
        ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(
          event.key,
        )
      ) {
        return
      }
      event.preventDefault()
    },
    async registerOrders() {
      try {
        this.isProcessing = true
        // display_order だけを抽出してAPIに渡す
        const orders = this.filteredChatbots.map((chatbot) => ({
          id: chatbot.id,
          display_order: chatbot.display_order,
        }))
        console.log(orders)
        await HTTPService.update_chatbot_display_order(orders)
        await this.getChatbots()
      } catch (error) {
        console.log(error)
      } finally {
        setTimeout(() => {
          this.isProcessing = false
        }, 1000)
      }
    },
  },
  components: {
    SoftButton,
    CCardText,
    CIcon,
    CModal,
    CModalTitle,
    CModalHeader,
    CModalBody,
    CModalFooter,
    CButton,
    Chatbot,
    ProcessingOverlay,
  },
}
</script>
<style scoped>
.chatbot-dashboard {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.chatbot-actions {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
}

.chatbot-list {
  flex: 1;
  padding: 10px;
}

h2 {
  margin-bottom: 10px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th {
  text-align: left;
  padding: 5px;
  background-color: #ccc;
}

td {
  padding: 5px;
}

tr:hover {
  cursor: pointer;
  background-color: #eee;
}

.settings-btn {
  padding: 5px 10px;
  border-radius: 5px;
  border: none;
  background-color: #eee;
  color: #333;
}

.start-chatbot-btn {
  padding: 5px 10px;
  border-radius: 5px;
  border: none;
  background-color: #00a0df;
  color: #fff;
}

.start-chatbot-btn:hover {
  cursor: pointer;
  background-color: #0089b9;
}

/* Ensure that the CModal component is displayed above other elements */
.modal-content {
  z-index: 9999;
}

.chatbot-input-label {
  font-size: 14px;
  margin-bottom: 5px;
  display: inline-block;
  font-weight: 700;
}

.chatbot-input {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
  line-height: 1.5rem;
  outline: none;
}

.chatbot-input-color {
  width: 25%;
  padding: 0px;
  height: 30px;
  /* border: none; */
  overflow: hidden;
  border-radius: 10px;
  box-shadow:
    0 0 0 1px white,
    0 0 0 2px black;
  cursor: pointer;
  outline: none;
}
.chatbot-setting-row {
  align-items: center;
  margin-bottom: 10px;
  margin-top: 10px;
}
input {
  outline: none;
}
.delete-icon {
  cursor: pointer;
}

.delete-icon:hover {
  outline: 1px solid #000;
  border-radius: 5px;
}
</style>
